<div
  class="bg d-flex overflow-hidden"
  [ngStyle]="themeService.getThemeLayoutStyles()"
  [ngClass]="{ 'bg-none': !!themeService.getThemeObj()?.video_url }"
>
  @if (themeService.getThemeObj()?.video_url) {
    <div class="video-box position-fixed">
      <video #videoRef id="video" class="video" loop muted playsinline (loadeddata)="videoPlay()">
        <source [src]="$safeNavigationMigration(themeService.getThemeObj()?.video_url)" />
      </video>
    </div>
  }
  <app-left-menu></app-left-menu>
  <div class="w-100 d-flex flex-column min-h-0 min-w-0" [style.padding-left]="baseService.isMobile ? 0 : '64px'">
    <app-header class="shrink-0"></app-header>
    <main class="w-100 min-h-0 flex-1 overflow-auto overscroll-y-contain crm-scroll">
      <audio id="audio-toast" hidden="hidden" controls muted>
        <source src="/assets/mp3/toast_sound.mp3" />
      </audio>
      <router-outlet></router-outlet>
    </main>
    <app-footer class="shrink-0"></app-footer>
  </div>
</div>
